import keyBy from 'lodash/keyBy'

// dict
import D2C_Instance from './Instance'
import D2C_Region from './Region'
import D2C_Tariff from './Tariff'
import D2C_User from './User'
// entities
import D2C_Account from './Account'
import D2C_Container from './Container'
import D2C_Entity from './Entity'
import D2C_Host from './Host'
import D2C_Key from './Key'
import D2C_Member from './Member'
import D2C_Project from './Project'
import D2C_Provider from './Provider'
import D2C_Role from './Role'
import D2C_Service from './Service'
// other
import D2C_Stack from './Stack'

// dict types
import instances from './instances'
import tariffs from './tariffs'
// entity types
import hosts from './hosts'
import keys from './keys'
import providers from './providers'
import services from './services'

const objects = {
  // dict
  Instance: D2C_Instance,
  Region: D2C_Region,
  Tariff: D2C_Tariff,
  User: D2C_User,
  // entities
  Account: D2C_Account,
  Container: D2C_Container,
  Entity: D2C_Entity,
  Host: D2C_Host,
  Key: D2C_Key,
  Member: D2C_Member,
  Project: D2C_Project,
  Provider: D2C_Provider,
  Role: D2C_Role,
  Service: D2C_Service,
  // other
  Stack: D2C_Stack,
  // entity types
  ...hosts,
  ...instances,
  ...keys,
  ...providers,
  ...services,
  ...tariffs,
  // getters
  get _hosts() {
    return Object.values(hosts).filter(host => host.objectType === 'hostType')
  },
  get _hostsByType() {
    return keyBy(Object.values(this._hosts), 'providerType')
  },
  get _instances() {
    return Object.values(instances).filter(host => host.objectType === 'instanceType')
  },
  get _instancesByType() {
    return keyBy(Object.values(this._instances), 'providerType')
  },
  get _keys() {
    return Object.values(keys).filter(key => key.objectType === 'keyType')
  },
  get _keysByType() {
    return keyBy(Object.values(this._keys), 'keyType')
  },
  get _providers() {
    return Object.values(providers).filter(provider => provider.objectType === 'providerType')
  },
  get _providersByType() {
    return keyBy(Object.values(this._providers), 'providerType')
  },
  get _services() {
    return Object.values(services).filter(provider => provider.objectType === 'serviceType')
  },
  get _servicesByType() {
    return keyBy(Object.values(this._services), 'typeName')
  },
  get _tariffs() {
    return Object.values(tariffs).filter(tariff => tariff.objectType === 'tariffType')
  },
  get _tariffsById() {
    return keyBy(Object.values(this._tariffs), 'tariffId')
  },
}

export default objects
